import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';

import { RouteWithSubRoutes } from 'shared/components/route';
import { WORKFLOWS_PATH } from 'shared/constants/routePaths';
import routes from '../../routes';

/**
 * This represents the main routes in the application, it will contain anything in the Navigation Bar
 * @returns Redux-Router components based on their route paths
 */
export const AppPageRoutes = () => {
  return (
    <Switch>
      <Route exact path="/">
        <Redirect to={WORKFLOWS_PATH} />
      </Route>
      {routes.map((route) => (
        <RouteWithSubRoutes
          key={route.name}
          {...route}
        />
      ))}
    </Switch>
  );
};
